/* eslint-disable array-callback-return */

import { Action } from "../actionTypes";

const initState = {
    UserCard: [],
    UserCardObj: {},
    UserCart: [],
    UserCartObj: {},
    UserMarker: [],
    UserMarkerObj: {},
    UserOrders: [],
    MultiMarker: [],
    MultiMarkerObj: {},
    MultiCard: [],
    MultiCardObj: {},
    card: {},
    marker: {},
    error: "",
    DeletedCard: [],
    DeletedMarker: [],
    ActiveCard: [],
    analytics: {},
    todayanalytics: {},
    UserAsset: {},
    AllAssets: [],
    isLoading: false,
    isCreatingCard: false,
};
const store = (state = initState, action: any) => {
    switch (action.type) {
        case Action.GET_CART_INIT:
            return {
                ...state
            }
        case Action.GET_CART_SUCCESS:
            let cartObj = {};
            action?.payload?.map((cart: any) => {
                cartObj[cart.variant_id] = cart
            })
            return {
                ...state,
                UserCart: action?.payload,
                UserCartObj: cartObj
            }
        case Action.GET_CART_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_ALL_CARD_INIT:
            return {
                ...state
            }
        case Action.GET_ALL_CARD_SUCCESS:
            let cardObj = {};
            action?.payload?.map((card: any) => {
                cardObj[card._id] = card
            })
            return {
                ...state,
                UserCard: action?.payload,
                UserCardObj: cardObj
            }
        case Action.GET_ALL_CARD_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_MULTI_CARD_INIT:
            return {
                ...state
            }
        case Action.GET_MULTI_CARD_SUCCESS:
            let MultiCardObj = {};
            action?.payload?.map((card: any) => {
                MultiCardObj[card._id] = card
            })
            return {
                ...state,
                MultiCard: action?.payload,
                MultiCardObj: MultiCardObj
            }
        case Action.GET_MULTI_CARD_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_ALL_MARKER_INIT:
            return {
                ...state
            }
        case Action.GET_ALL_MARKER_SUCCESS:
            let MultiMarkerObj = {};
            action?.payload?.map((marker: any) => {
                MultiMarkerObj[marker._id] = marker
            })
            return {
                ...state,
                UserMarker: action?.payload,
                UserMarkerObj: MultiMarkerObj
            }
        case Action.GET_ALL_MARKER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_MULTI_MARKER_INIT:
            return {
                ...state
            }
        case Action.GET_MULTI_MARKER_SUCCESS:
            let markerObj = {};
            action?.payload?.map((marker: any) => {
                markerObj[marker._id] = marker
            })
            return {
                ...state,
                MultiMarker: action?.payload,
                MultiMarkerObj: markerObj
            }
        case Action.GET_MULTI_MARKER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_ALL_ORDERS_INIT:
            return {
                ...state
            }
        case Action.GET_ALL_ORDERS_SUCCESS:
            return {
                ...state,
                UserOrders: action?.payload
            }
        case Action.GET_ALL_ORDERS_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_ALL_DELETE_CARD_INIT:
            return {
                ...state
            }
        case Action.GET_ALL_DELETE_CARD_SUCCESS:
            return {
                ...state,
                DeletedCard: action?.payload
            }
        case Action.GET_ALL_DELETE_CARD_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_ALL_DELETE_MARKER_INIT:
            return {
                ...state
            }
        case Action.GET_ALL_DELETE_MARKER_SUCCESS:
            return {
                ...state,
                DeletedMarker: action?.payload
            }
        case Action.GET_ALL_DELETE_MARKER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_ACTIVE_CARD_INIT:
            return {
                ...state
            }
        case Action.GET_ACTIVE_CARD_SUCCESS:
            return {
                ...state,
                ActiveCard: action?.payload
            }
        case Action.GET_ACTIVE_CARD_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.CLEAR_CARD_STATE:
            return {
                ...state,
                card: {},
                marker: {},
                error: ""
            }
        case Action.GET_ONE_CARD_INIT:
            return {
                ...state
            }
        case Action.GET_ONE_CARD_SUCCESS:
            return {
                ...state,
                card: action?.payload
            }
        case Action.GET_ONE_CARD_FAIL:
            return {
                ...state,
                error: action?.payload
            }
            case Action.GET_ONE_MARKER_INIT:
                return {
                    ...state
                }
            case Action.GET_ONE_MARKER_SUCCESS:
                return {
                    ...state,
                    marker: action?.payload
                }
            case Action.GET_ONE_MARKER_FAIL:
                return {
                    ...state,
                    error: action?.payload
                }
        case Action.GET_CARD_ANALYTICS_INIT:
            return {
                ...state
            }
        case Action.GET_CARD_ANALYTICS_SUCCESS:
            return {
                ...state,
                analytics: action?.payload
            }
        case Action.GET_CARD_ANALYTICS_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_TODAY_ANALYTICS_INIT:
            return {
                ...state
            }
        case Action.GET_TODAY_ANALYTICS_SUCCESS:
            return {
                ...state,
                todayanalytics: action?.payload
            }
        case Action.GET_TODAY_ANALYTICS_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        // Asset Reducers (consider moving these to their own tsx file)

        case Action.GET_ALL_ASSETS_INIT:
            return {
                ...state
            }
        case Action.GET_ALL_ASSETS_SUCCESS:
            return {
                ...state,
                AllAssets: action?.payload
            }
        case Action.GET_ALL_ASSETS_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.POST_ADD_TO_CART_INIT:
            return {
                ...state
            }
        case Action.POST_ADD_TO_CART_SUCCESS:
            const newitem = action?.payload;
            const variantid = newitem?.variant_id;
            const userCartObj = {...state?.UserCartObj};
            const userCartMerge = {...userCartObj, [variantid]: newitem};
            const newCart = Object.values(userCartMerge);
            return {
                ...state,
                UserCart: newCart,
                UserCartObj: userCartMerge
            }
        case Action.POST_ADD_TO_CART_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.POST_REMOVE_FROM_CART_INIT:
            return {
                ...state
            }
        case Action.POST_REMOVE_FROM_CART_SUCCESS:
            const variant_id = action?.payload;
            let cart = {...state?.UserCartObj};
            delete cart[variant_id];
            const fincart = Object.values(cart);
            return {
                ...state,
                UserCart: fincart,
                UserCartObj: cart
            }
        case Action.POST_REMOVE_FROM_CART_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.POST_CREATE_ASSET_INIT:
            return {
                ...state
            }
        case Action.POST_CREATE_ASSET_SUCCESS:
            return {
                ...state,
                UserAsset: action?.payload
            }
        case Action.POST_CREATE_ASSET_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.POST_UPDATE_ASSET_INIT:
            return {
                ...state
            }
        case Action.POST_UPDATE_ASSET_SUCCESS:
            return {
                ...state,
                UserAsset: action?.payload
            }
        case Action.POST_UPDATE_ASSET_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.POST_CREATE_CARD_INIT:
            return {
                ...state,
                isCreatingCard: true
            }
        case Action.POST_CREATE_CARD_SUCCESS:
            return {
                ...state,
                isCreatingCard: false,
                card: action?.payload
            }
        case Action.POST_CREATE_CARD_FAIL:
            return {
                ...state,
                isCreatingCard: false,
                error: action?.payload
            }

        default:
            return state;
    }
}

export default store;
